import React from "react";
import { withStyles } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import EditCannedMessages from "./EditCannedMessages";
import { Header, WithChatWindow } from "../../common";
import {
  Close as CloseButton,
  Urgent as UrgentButton,
} from "./../../common/Buttons";
import { compose } from "recompose";
import constants from "../../constants";

const styles = (theme) => ({
  listItemText: {
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: theme.headerTextFontSize,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: theme.TextColor,
    margin: "0px",
    paddingBottom: "8px",
    background: theme.ComponentHeader,
  },
  radioColor: {
    color: theme.TextColor,
  },
  textFieldClass: {
    width: 112
  }
});

class CannedMessages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditable: false,
      editMsg: "",
      messages: constants.CANNED_MESSAGES,
      isUrgent: false
    };
  }
  cancelEditMessage = () => {
    this.setState({ editMsg: "", isEditable: false });
  };
  sendText = (event) => {
    const messageInput = this.state.messages[parseInt(event.target.value)];
    if (messageInput.isEditable) {
      this.setState({ editMsg: messageInput, isEditable: true });
    } else {
      this.props.onMessageSubmit({ message: messageInput.text , isUrgent: this.state.isUrgent});
    }
  };

  toggleUrgent = () => {
    this.setState((state) => ({
      isUrgent: !state.isUrgent,
    }));
  };

  render() {
    const { classes, pendingCustomers, handleCannedMessageClick } = this.props;
    const { isEditable, messages, editMsg , isUrgent} = this.state;

    return (
      <>
        {!isEditable ? (
          <div component="fieldset">
            <Header title="Canned Messages">
              <UrgentButton onClick={this.toggleUrgent} isMarkedAsUrgent={isUrgent}/>
              <CloseButton onClick={() => handleCannedMessageClick(false)} />
            </Header>
            <div
              className={`${classes.viewCannedMessageContainer} customScroll`}
            >
              <RadioGroup
                aria-label="Messages"
                name="Messages"
                onChange={this.sendText}
              >
                {messages.map((msg, i) => (
                  <FormControlLabel
                    className={classes.listItemText}
                    classes={{ label: classes.radioColor }}
                    value={`${i}`}
                    control={<Radio className={classes.radioColor} />}
                    key={`${i}msg`}
                    label={msg.text}
                  />
                ))}
              </RadioGroup>
            </div>
          </div>
        ) : (
          <EditCannedMessages
            classes={classes}
            pendingCustomers={pendingCustomers}
            isEditable={isEditable}
            editMsg={editMsg}
            onMessageSubmit={this.props.onMessageSubmit}
            cancelEditMessage={this.cancelEditMessage}
            isUrgent={this.state.isUrgent}
            toggleUrgent={this.toggleUrgent}
          ></EditCannedMessages>
        )}
      </>
    );
  }
}

export default compose(withStyles(styles), WithChatWindow)(CannedMessages);
